// extracted by mini-css-extract-plugin
export default {"slider":"slider_slider__PC7aZ","item":"slider_item__0sV0L","itemActive":"slider_itemActive__Rz5YP"};